import InterviewReviewsManager from './InterviewReviewsManager.container';

export default InterviewReviewsManager;
